<template>
  <sf-dialog v-model="dialog">
    <template #activator="{ props }">
      <sf-edit-button v-bind="props" :aria-label="$t('editCollectionAssignee')" />
    </template>
    <v-card>
      <v-card-item>
        <v-card-title>
          <sf-heading>{{ $t('collection.assignee') }}</sf-heading>
        </v-card-title>
      </v-card-item>
      <v-card-text>
        <collection-assignee-select v-model="assignedUser" :users="users" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <sf-text-button color="grey" class="text-medium-emphasis" @click="closeDialog">
          {{ $t('cancel') }}
        </sf-text-button>
        <sf-text-button color="primary" :disabled="!assignedUser" @click="save">
          {{ $t('save') }}
        </sf-text-button>
      </v-card-actions>
    </v-card>
  </sf-dialog>
</template>

<script setup lang="ts">
import SfEditButton from '@/components/button/SfEditButton.vue'
import SfTextButton from '@/components/button/SfTextButton.vue'
import SfDialog from '@/components/dialog/SfDialog.vue'
import SfHeading from '@/components/text/SfHeading.vue'
import CollectionAssigneeSelect from '@/modules/collection/components/CollectionAssigneeSelect.vue'
import useCollection from '@/modules/collection/useCollection'
import { ShortUser } from '@/types/index'
import { PropType, ref, watch } from 'vue'

const componentProps = defineProps({
  assignee: {
    type: Object as PropType<ShortUser | undefined>,
    required: true
  },
  users: {
    type: Array as PropType<ShortUser[]>,
    required: true
  }
})

const dialog = ref(false)
const assignedUser = ref(componentProps.assignee)

// set correct data when dialog is reopened
watch(dialog, (newValue) => {
  if (newValue) {
    assignedUser.value = componentProps.assignee
  }
})

const closeDialog = () => {
  dialog.value = false
}

const save = () => {
  if (assignedUser.value != undefined) {
    useCollection().updateAssignee(assignedUser.value)
    dialog.value = false
  }
}
</script>
